import Dock from './Dock';
import SampleStation from './SampleStation';
import LoopStation from './LoopStation';

const Kit = () => {
  return (
    <>
      <Dock />
      <SampleStation />
      <LoopStation />
    </>
  )
}

export default Kit
